"use client";
import Link from "next/link";
import { Link as MuiLink, type LinkProps as MuiLinkProps } from "@mui/material";

type MuiLinkRouteProps = MuiLinkProps<typeof Link>;

export default function MuiLinkRoute(props: MuiLinkRouteProps) {
    return <MuiLink component={Link} {...props} />;
}
